import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 2rem;
`;

export const FormFieldsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const GroupWrapper = styled.div`
  margin-top: 1.5rem;
`;

export const GroupWrapperStyled = styled.div`
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #f2eff4;
  border: 1px solid #d8d8d8;
`;

export const GroupTitle = styled.div`
  margin: 1rem 0;
  color: #49166d;
  font-size: 1.2rem;
`;

export const RepeatedFormGroup = styled.div`
  background: #f2eff4;
  padding: 1rem 2rem;
  border: 1px solid #d8d8d8;
  margin-top: 2rem;
`;

export const RepeatedFormTitle = styled.div`
  margin: 1rem 0;
  color: #54595f;
  font-size: 1rem;
  font-weight: 500;
`;

export const SummaryGroupWrapper = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.5rem;
`;

export const SummaryCategory = styled.div`
  color: #ababab;
  width: 250px;
  padding-right: 20px;
  padding: 10px;
  float: left;
  background: #f7f7f8;
`;

export const SummaryDetail = styled.div`
  padding-right: 20px;
  padding: 10px;
  float: left;
`;

export const ModalFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Button = styled.button`
  margin: 0.5em auto;
  width: 20%;
`;

export const ButtonsWrapper = styled.div`
  margin-bottom: 3em;
`;

export const SeatDetailsButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  left: 0;
  padding: 1.5rem 1rem;
  border-top: 5px solid #4b286d;
  z-index: 1;
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  padding: 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;

export const TableWrapper = styled.div`
  border: 1px solid #9a9a9a;
  width: 50%;
`;

export const BoxWrapper = styled.div`
  display: flex;
  padding: 1rem 0;
`;

export const FormTitle = styled.div`
  font-size: 32px;
  margin-left: 2%;
  margin-bottom: 20px;
`;
